import React from 'react';
import moment from 'moment';

import TableRowContainer from './TableRowContainer';
import TableCell from './TableCell';
import StatusCircle from './StatusCircle';
import StatusButton from './StatusButton';

/* eslint-disable-next-line */
const TableRow = ({ campaign, onCancel, onPreview, disableCancel }) => {
  if (!campaign) return null;

  const dateFormat = "ddd D MMM, h:mm a";
  // const currentDate = new Date();
  const startDate = moment(campaign.startDate).utc(false);
  const endDate = moment(campaign.endDate).utc(false);

  const startDateFormatted = startDate.format(dateFormat);
  const endDateFormatted = endDate.format(dateFormat);

  // const isLive = startDate.toDate() <= currentDate && endDate.toDate() > currentDate && campaign.status === 'approved';

  return (
    <TableRowContainer>
      {/* <TableCell><StatusCircle status={campaign.isLive ? 'live' : null} /></TableCell> */}
      <TableCell flex={4}>
        <div style={{ maxWidth: 275, overflow: 'hidden' }}>{campaign.campaignName || 'Unnamed'}</div>
      </TableCell>
      <TableCell flex={3.5}>{campaign.states.map(s => s.toUpperCase()).join(', ') || 'None'}</TableCell>
      <TableCell flex={2}>{startDateFormatted || ''}</TableCell>
      <TableCell flex={2}>{endDateFormatted || ''}</TableCell>
      <TableCell center flex={1}>
        <StatusButton
          url="/images/preview.png"
          onClick={onPreview}
        />
      </TableCell>
      <TableCell center flex={1}>
        {disableCancel ? null : (
          <StatusButton
            url="/images/cancel.png"
            onClick={onCancel}
          />
        )}
      </TableCell>
      <TableCell flex={1.5} style={{ display: 'flex', flexDirection: 'row' }}>
        <StatusCircle status={campaign.status} />
        {campaign.status && campaign.status.toUpperCase()}
      </TableCell>
    </TableRowContainer>
  );
};

export default TableRow;




// WEBPACK FOOTER //
// ./client/Dashboard/components/TableRow.js